export const PERFORMANCESCORE_LOADING = "PERFORMANCESCORE_LOADING";
export const PERFORMANCESCORE_RESET = "PERFORMANCESCORE_RESET";
export const GET_PERFORMANCESCORE = "GET_PERFORMANCESCORE";
export const GET_PERFORMANCESCORE_SUCCESS = "GET_PERFORMANCESCORE_SUCCESS";
export const GET_PERFORMANCESCORE_FAIL = "GET_PERFORMANCESCORE_FAIL";
export const DELETE_PERFORMANCESCORE = "DELETE_PERFORMANCESCORE"
export const DELETE_PERFORMANCESCORE_SUCCESS = "DELETE_PERFORMANCESCORE_SUCCESS"
export const DELETE_PERFORMANCESCORE_FAIL = "DELETE_PERFORMANCESCORE_FAIL"
export const UPDATE_PERFORMANCESCORE = "UPDATE_PERFORMANCESCORE"
export const UPDATE_PERFORMANCESCORE_SUCCESS = "UPDATE_PERFORMANCESCORE_SUCCESS"
export const UPDATE_PERFORMANCESCORE_FAIL = "UPDATE_PERFORMANCESCORE_FAIL"
export const ADD_NEW_PERFORMANCESCORE = "ADD_NEW_PERFORMANCESCORE"
export const ADD_PERFORMANCESCORE_SUCCESS = "ADD_PERFORMANCESCORE_SUCCESS"
export const ADD_PERFORMANCESCORE_FAIL = "ADD_PERFORMANCESCORE_FAIL"